import PropTypes from 'prop-types';

export const Icons = ({ testid, className, variant, onClick, color, svgClass }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.NEW_SEARCH: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23 14.5C18.3056 14.5 14.5 18.3056 14.5 23C14.5 27.6944 18.3056 31.5 23 31.5C27.6944 31.5 31.5 27.6944 31.5 23C31.5 18.3056 27.6944 14.5 23 14.5ZM9.5 23C9.5 15.5442 15.5442 9.5 23 9.5C30.4558 9.5 36.5 15.5442 36.5 23C36.5 30.4558 30.4558 36.5 23 36.5C15.5442 36.5 9.5 30.4558 9.5 23Z"
              fill="#51BFE1"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.7678 29.2322L41.7678 38.2322C42.7441 39.2085 42.7441 40.7915 41.7678 41.7678C40.7915 42.7441 39.2085 42.7441 38.2322 41.7678L29.2322 32.7678C26.9524 30.4879 30.4879 26.9524 32.7678 29.2322Z"
              fill="#51BFE1"
            />
          </svg>
        );
      }

      case Icons.MY_SEARCH: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.1665 15.5C15.1665 12.7386 17.4051 10.5 20.1665 10.5H31.8332C34.5946 10.5 36.8332 12.7386 36.8332 15.5V40C36.8332 40.5453 36.5373 41.0476 36.0603 41.312C35.5834 41.5763 35.0006 41.561 34.5382 41.272L25.9998 35.9355L17.4615 41.272C16.9991 41.561 16.4163 41.5763 15.9394 41.312C15.4624 41.0476 15.1665 40.5453 15.1665 40V15.5Z"
              fill="#928CDA"
            />
          </svg>
        );
      }

      case Icons.TOURS: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.0001 9C36.0001 7.89543 35.1047 7 34.0001 7C32.8956 7 32.0001 7.89543 32.0001 9V9.60156H20.0001V9C20.0001 7.89543 19.1047 7 18.0001 7C16.8956 7 16.0001 7.89543 16.0001 9V9.60156H15.2001C12.1073 9.60156 9.6001 12.1088 9.6001 15.2016V36.8016C9.6001 39.8944 12.1073 42.4016 15.2001 42.4016H36.8001C39.8929 42.4016 42.4001 39.8944 42.4001 36.8016V15.2016C42.4001 12.1088 39.8929 9.60156 36.8001 9.60156H36.0001V9ZM16.0001 13V12.9998C15.6862 13.4176 15.5001 13.9371 15.5001 14.5C15.5001 15.8807 16.6194 17 18.0001 17C19.3808 17 20.5001 15.8807 20.5001 14.5C20.5001 13.9371 20.3141 13.4176 20.0001 12.9998V13C20.0001 14.1046 19.1047 15 18.0001 15C16.8956 15 16.0001 14.1046 16.0001 13ZM32.0001 12.9998V13C32.0001 14.1046 32.8956 15 34.0001 15C35.1047 15 36.0001 14.1046 36.0001 13V12.9998C36.3141 13.4176 36.5001 13.9371 36.5001 14.5C36.5001 15.8807 35.3808 17 34.0001 17C32.6194 17 31.5001 15.8807 31.5001 14.5C31.5001 13.9371 31.6862 13.4176 32.0001 12.9998ZM13.6001 36.8016V21.5H38.4001V36.8016C38.4001 37.6852 37.6838 38.4016 36.8001 38.4016H15.2001C14.3164 38.4016 13.6001 37.6852 13.6001 36.8016ZM22.3995 27.8008C21.295 27.8008 20.3995 28.6962 20.3995 29.8008C20.3995 30.9053 21.295 31.8008 22.3995 31.8008H29.5995C30.7041 31.8008 31.5995 30.9053 31.5995 29.8008C31.5995 28.6962 30.7041 27.8008 29.5995 27.8008H22.3995Z"
              fill="#51BFE1"
            />
          </svg>
        );
      }

      case Icons.TOP_MATCHES: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M43 25.8017V34.9996C43 38.8656 39.866 41.9996 36 41.9996H21C19.3431 41.9996 18 40.6564 18 38.9996C18 38.7234 18.2239 38.4996 18.5 38.4996H34.5C37.2614 38.4996 39.5 36.261 39.5 33.4996V22.5604C39.5 22.1376 39.9921 21.9057 40.3182 22.1748L41.9094 23.4879C42.6 24.0578 43 24.9064 43 25.8017Z"
              fill="#4673D1"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.3417 9.15123C22.8989 7.95409 25.0525 7.90516 26.6624 9.03035L35.5779 15.2616C36.7824 16.1035 37.5 17.4805 37.5 18.95V31.9996C37.5 34.4849 35.4853 36.4996 33 36.4996H15C12.5147 36.4996 10.5 34.4849 10.5 31.9996V19.7031C10.5 18.3056 11.1493 16.9873 12.2572 16.1356L21.3417 9.15123Z"
              fill="#4673D1"
            />
          </svg>
        );
      }

      case Icons.AGENT_HIGHLIGHTS: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.9104 10.1835C24.7662 8.44926 27.2392 8.44924 28.0951 10.1835L32.1421 18.3837L41.1905 19.6977C43.1044 19.9757 43.8688 22.3277 42.4838 23.6777L35.9362 30.0602L37.4823 39.0736C37.8093 40.9797 35.8086 42.4334 34.0967 41.5334L26.0027 37.2778L17.9088 41.5334C16.1969 42.4334 14.1962 40.9797 14.5232 39.0736L16.0693 30.0602L9.52164 23.6777C8.1367 22.3277 8.90105 19.9757 10.815 19.6977L19.8633 18.3837L23.9104 10.1835Z"
              fill="#FB913A"
            />
          </svg>
        );
      }

      case Icons.FAVORITES: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 20.5612C8 14.71 12.7661 10 18.6043 10C21.4783 10 24.0889 11.1401 26 12.9924C27.9112 11.1401 30.5217 10 33.3956 10C39.2339 10 44 14.71 44 20.5612C44 23.5369 42.7627 26.2239 40.7821 28.139L29.7145 39.4358C27.6715 41.5211 24.3286 41.5214 22.2852 39.4365L10.9607 27.8818C9.1307 25.9869 8 23.4054 8 20.5612Z"
              fill="#FF576D"
            />
          </svg>
        );
      }

      default:
        return null;
    }
  };
  return (
    <div testid={testid} onClick={onClick} className={className}>
      {renderIcon()}
    </div>
  );
};

Icons.NEW_SEARCH = 'newSearch';
Icons.MY_SEARCH = 'mySearch';
Icons.TOURS = 'tours';
Icons.TOP_MATCHES = 'topMatches';
Icons.AGENT_HIGHLIGHTS = 'agentHighlights';
Icons.FAVORITES = 'favorites';

Icons.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  testid: PropTypes.string,
  svgClass: PropTypes.string,
};

Icons.defaultProps = {
  svgClass: '',
  className: '',
  variant: '',
  color: '',
  testid: undefined,
  onClick: () => {},
};
